"use strict";

exports["default"] = function (obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
};

exports.__esModule = true;


//////////////////
// WEBPACK FOOTER
// /~/react-bootstrap/~/babel-runtime/helpers/interop-require-default.js
// module id = 8
// module chunks = 0